var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-config-provider", { attrs: { locale: _vm.zh_CN } }, [
    _c(
      "div",
      { attrs: { id: "app" } },
      [_vm.isRouterAlive ? _c("router-view") : _vm._e(), _c("Common")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }